export default __webpack_public_path__ + "static/media/NewPatientPacket.99cd5f69.pdf";